// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_iMt","cls2":"RecommendedPodcasts-cls2_WTK RecommendedPodcasts-cls1_iMt"};